import {
  GetPolicyPageQuery,
  GetPolicyPageQueryVariables,
} from '../gql/graphql';

import { getPaginatedNodes } from './utils';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const GET_POLICY_PAGE = graphql(`
  query getPolicyPage($submissionUuid: String) {
    quotes(
      filters: {
        submissionUuid: $submissionUuid
        type: USER_QUOTE
        status: BOUND
      }
      sort: { order: "ASC", key: "order" }
    ) {
      pageInfo {
        totalResults
      }
      edges {
        cursor
        node {
          uuid
          referenceId
          createdAt
          updatedAt
          type
          name
          order
          quotedPremium
          selectedQuotedPremium
          limit
          retention
          ratedPremium
          technicalPremium
          modifiedCoveragePremium
          status
          excessConvergeQuotedPremium
          excessConvergeLimit
          excessConvergeAttachmentPoint
          policies {
            edges {
              node {
                uuid
                referenceId
                renewalInstructionType
              }
            }
          }
          subjectivities {
            edges {
              cursor
              node {
                uuid
                name
                type
                order
                afterPolicy
                quote {
                  uuid
                  createdAt
                  included
                  deadline
                  isSatisfied
                  waived
                }
              }
            }
          }
          coverages(sort: { key: "order", order: "ASC" }) {
            edges {
              cursor
              node {
                uuid
                name
                type
                order
                score
                minScore
                maxScore
                createdAt
                updatedAt
                quote {
                  hazardGroup
                  basePremium
                  fusionScore
                  fusionScoreModifier
                  ratedFusionScoreModifier
                  selectedFusionScoreModifier
                  included
                  limit
                  modifiedCoveragePremium
                  restorationPeriodDays
                  retention
                  technicalPremium
                  uuid
                  waitingPeriodHours
                }
                controls {
                  edges {
                    cursor
                    node {
                      uuid
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export function useGetPolicyPageQuery({
  quoteUuid,
  ...variables
}: GetPolicyPageQueryVariables & { quoteUuid: string }) {
  const { loading, error, data, refetch } = useQuery(GET_POLICY_PAGE, {
    variables,
  });

  const info = useMemo(
    () => getInfo({ quoteUuid, ...variables }, data),
    [data, quoteUuid, variables]
  );

  return {
    error,
    loading,
    data,
    info,
    refetch,
  };
}

const getInfo = (
  variables: GetPolicyPageQueryVariables & { quoteUuid: string },
  data?: GetPolicyPageQuery
) => {
  const quote = getPaginatedNodes(data?.quotes).find(
    (quote) => variables.quoteUuid && quote.uuid === variables.quoteUuid
  );

  const subjectivities = getPaginatedNodes(quote?.subjectivities).filter(
    (e) => e.quote?.included === true
  );

  return {
    quote,
    subjectivities,
  };
};
